import useGlobalStore from '@/stores/global.store';
import { useQueryClient } from '@tanstack/react-query';
import { useCancelPaymentMutation } from './mutations/use-cancel-payment-mutation';
import * as React from 'react';

export function useCancelPayment() {
  const queryClient = useQueryClient();
  const paymentId = useGlobalStore((state) => state.paymentId);
  const stopPayment = useGlobalStore((state) => state.stopPayment);

  const { mutate } = useCancelPaymentMutation({
    onSuccess: () => {
      stopPayment();
      queryClient.invalidateQueries({
        queryKey: ['payments'],
      });
    },
    onError: () => {
      // Even if the backend cancel call fails, the user asked to stop —
      // don't leave the frontend polling a payment it no longer cares about.
      console.error('Could not cancel payment.');
      stopPayment();
    },
  });

  const cancel = React.useCallback(() => {
    if (!paymentId) return;

    mutate(paymentId);
  }, [paymentId]);

  return { cancel };
}
